// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__cyuL1","head":"ProcedureTableInfo_head__154rq"};